var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemAlertaAviso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFB642",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.608 10.742L8.72 1.004c-.794-1.338-2.731-1.34-3.527 0L.3 10.742c-.812 1.367.114 3.237 1.706 3.237h9.84c1.592 0 2.574-1.869 1.762-3.237zm-6.65.81c-.453 0-.82-.368-.82-.82 0-.452.367-.82.82-.82.452 0 .82.368.82.82 0 .452-.368.82-.82.82zm.82-3.281c0 .452-.368.82-.82.82-.453 0-.82-.368-.82-.82V4.169c0-.452.367-.82.82-.82.452 0 .82.368.82.82v4.102z",
    transform: "translate(-337 -442) translate(22 265) translate(315 177) translate(.042 .02)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemAlertaAviso);
export default __webpack_public_path__ + "static/media/system-alerta-aviso.f8b2be3a.svg";
export { ForwardRef as ReactComponent };